import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import TableWidget from "../../../components/tables/TableWidget";
import {
  getTransportHistoryTableData,
  transportHistoryTableHeader,
} from "./components/tableConfigs/transportHistoryTableConfig";
import TransportHistoryActionButton from "./components/TableActionsButtonsComponent/TransportHistoryActionButton";
import { fetchTransportHistory } from "../../../redux/api/transport.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { clearTransportHistoryData } from "../../../redux/reducer/transport.reducer";
import TransportHistoryHeader from "./components/TransportHistoryHeader";
import { getTransportHistoryFilters } from "./transportHistoryFilters";

function TransportHistory() {
  const dispatch = useAppDispatch();

  const {
    transport: {
      transportHistory: {
        data: { data: transportHistory, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    transport: state.transport,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        fetchTransportHistory({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          ...getTransportHistoryFilters(action.tableSearch),
        }),
      );
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearTransportHistoryData());
    };
  }, [dispatch]);

  return (
    <TableWidget
      CustomHeaderComponent={TransportHistoryHeader}
      tableHeaderData={transportHistoryTableHeader}
      tableItemsData={getTransportHistoryTableData(transportHistory)}
      tableLoading={isLoading}
      ActionButtonsComponent={TransportHistoryActionButton}
      handleTableActions={handleTableActions}
      totalItems={total}
      borderedRow
    />
  );
}

export default TransportHistory;
